<template>
  <div>
    <TopContent
      :gelentur="gelentur"
      @aranan="aranan"
      @secilenDurum="secilenDurum"
    />
    
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import TopContent from "../components/uzum-components/finans-components/TopContent.vue";
import SatinalmaIslemiButon from "../components/uzum-components/finans-components/SatinalmaIslemiButon.vue";

import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
export default {
  data() {
    return {
      columnDefs: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      gelentur: "Fatura",
      arananVal: "",
      rowData: [],
      dir: false,
      secilenDurumVal: "",
    };
  },
  components: {
    TopContent,
    AgGridVue,
    SatinalmaIslemiButon,
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    secilenDurum(value) {
      this.secilenDurumVal = value;
      this.listeleme();
    },
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    aranan(value) {
      this.arananVal = value;
      this.listeleme();
    },
    listeleme() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ISLEM: "Satınalma",
        ARANAN: vm.arananVal,
      };
      soap.createClient(url, function (err, client) {
        client.UZM_INVOICELIST(args, function (err, result) {
          if (result.UZM_INVOICELISTResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.UZM_INVOICELISTResult);
            vm.rowData = vm.veriler;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.listeleme();
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "SatinalmaIslemiButon",
      },

      {
        headerName: "İşlem",
        field: "ISLEM",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Tarih",
        field: "TARIH",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Fiş No",
        field: "FISNO",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Grup Kodu",
        field: "GROUPCODE",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Cari No",
        field: "ACTID",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Açıklama",
        field: "BASLIKACIKLAMA",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Teslim Alan",
        field: "TESLIMALAN",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Giriş Mik.",
        field: "GMIKTAR",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Çıkış Mik.",
        field: "CMIKTAR",
        filter: "agTextColumnFilter",
      },
    ];
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}

.vue-form-wizard.md .wizard-navigation .wizard-nav .wizard-icon-circle {
  border: 0 !important;
}

.vue-form-wizard .wizard-icon-circle {
  border-radius: 10px !important;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 5px !important;
  box-shadow: 1px 1px 8px #f08182;
}

.vue-form-wizard .wizard-nav-pills > li > a {
  flex-direction: row !important;
}
.vue-form-wizard.md .wizard-navigation .wizard-nav .stepTitle {
  margin-left: 25px !important;
  font-weight: 600;
}
[dir] .vue-form-wizard.md .wizard-navigation .wizard-nav .wizard-icon-circle {
  background-color: lavenderblush !important;
}
.vue-form-wizard .wizard-nav-pills > li.active > a,
[dir] .vue-form-wizard .wizard-nav-pills > li.active > a:focus,
[dir] .vue-form-wizard .wizard-nav-pills > li.active > a:hover {
  margin-left: 25px !important;
  // margin-right: 25px !important;
}

.vue-form-wizard .wizard-nav-pills a,
.vue-form-wizard .wizard-nav-pills li {
  margin-left: 25px !important;
}
.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  top: 68px !important;
  padding-left: 50px !important;
}
.vue-form-wizard.md
  .wizard-navigation
  .wizard-nav
  .wizard-icon-circle
  .wizard-icon {
  color: #ea5455;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  color: #fff !important;
}

</style>